import { Injectable, signal } from "@angular/core";
import { SocketService } from "../../../../../../core/service/socket/socket.service";

interface TrackingData {
  status: number;
  latitude: string;
  longitude: string;
  orderId: number;
  idRepartidor: number;
  timestamp: string;
}

@Injectable({
  providedIn: 'root'
})
export class MapNewTrackingService {
  statusAnterior=signal(0);
  status=signal(0);
  deliveryLocation=signal<{lat: number, lng: number} | null>(null);
  
  constructor(
    private socketService: SocketService
  ) {


  }


  joinRoom(orderId: number) {
    // console.log('unido a la room de la orden', orderId);

    this.socketService.emit('joinOrderRoom', { orderId });
  }

  listenTracking(orderId: number):number | undefined{
    this.socketService.on('orderTracking', (data: TrackingData) => {
      // console.log('orderTracking received:', data);
      if (data.orderId === orderId) {
        // console.log('Updating status from', this.status(), 'to', data.status);
        this.status.set(data.status);
        
        // Actualizar coordenadas del repartidor si están disponibles
        if (data.latitude && data.longitude) {
          const lat = parseFloat(data.latitude);
          const lng = parseFloat(data.longitude);
          
          if (!isNaN(lat) && !isNaN(lng)) {
            // console.log('Updating delivery location:', { lat, lng });
            this.deliveryLocation.set({ lat, lng });
          }
        }
      }
    });
    return this.status();
  }


}
